import { ChangeDetectionStrategy, Component } from '@angular/core';
import { B2BUser, UrlPipe, TranslatePipe } from '@spartacus/core';
import { ItemService, UserDetailsComponent, UserItemService, CardComponent, ToggleStatusComponent, DisableInfoComponent } from '@spartacus/organization/administration/components';
import { B2BUserService } from '@spartacus/organization/administration/core';
import { Subscription } from 'rxjs';
import { FocusDirective } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { ItemExistsDirective } from '../item-exists/item-exists.directive';
import { AsyncPipe } from '@angular/common';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'cx-org-user-details',
    templateUrl: './kn-br-user-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: ItemService,
            useExisting: UserItemService,
        },
    ],
    // tslint:disable-next-line: no-host-metadata-property
    host: { class: 'content-wrapper' },
    imports: [CardComponent, FocusDirective, RouterLink, ToggleStatusComponent, DisableInfoComponent, ItemExistsDirective, AsyncPipe, UrlPipe, TranslatePipe]
})
export class KnBrUserDetailsComponent extends UserDetailsComponent {
  constructor(protected itemService: ItemService<B2BUser>, protected b2bUserService: B2BUserService) {
    super(itemService, b2bUserService);
  }
}
